module.exports = __webpack_public_path__ + "static/media/SAM_0165.59d88b7f.JPG";